import React, { Component } from 'react';
import { Card, CardMedia, CardTitle } from 'material-ui/Card';
import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { Link } from 'react-router';
import AppStore from '../../stores/app-store.js'
import { preparaJogoActions } from '../../actions/app-actions.js'
import { historiaActions } from '../../actions/app-actions.js'
import '../../grid.css';
import './Carta1.css';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

const style = {
    margin: 12,
    float: 'right',
};

class Carta1 extends Component {
    constructor() {
        super();
        this.state = {
            carta1: {
                idoriginal: 0,
                key: 0,
                imgfrente: './imagens/cartas/acoes/Ajudar.png',
                titulofrente: 'Ajudar',
                titulofrenteingles: 'Help',
                imgverso: './imagens/cartas/fundos/Acoes.png',
                tituloverso: 'Ações',
                tituloversoingles: 'Actions',
                jogador: 0,
                jaescolhida: false,
                frente: true,
                selecionada: false,
                categoria: 'ACOES',
            },
            historiacarta: {
                idoriginal: 0,
                sequencia: 0,
                historia: '',
            },
            legendas: AppStore.legendas,
        }
        this.onChange = this.onChange.bind(this);
        this.embaralhando = true;
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        this.embaralhando = true;
        AppStore.addChangeCarta1Listener(this.onChange);
        AppStore.addChangeLinguaListener(this.onChangeLingua);
        historiaActions.iniciaHistoria();

    }

    componentDidMount() {
        preparaJogoActions.prepara();
    }

    componentWillUnmount() {
        AppStore.removeChangeCarta1Listener(this.onChange);
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
        historiaActions.sequenciaCarta(this.state.carta1.idoriginal);
    }


    onChange() {
        this.embaralhando = false;
        this.setState({
            carta1: AppStore.getCarta1(),
        })

    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }


    handleInputChange = (event) => {
        this.setState({
            historiacarta: {
                historia: event.target.value,
            }
        });
        historiaActions.sequenciaHistoria(event.target.value);
    };

    render() {
        if (this.embaralhando) {
            return (
                <MuiThemeProvider muiTheme={muiTheme}>
                    <div className="Carta1">
                        <h2>{this.state.legendas.cartaInicial}</h2>
                        <h3>{this.state.legendas.embaralhando}</h3>
                    </div>
                </MuiThemeProvider>
            );
        } else {
            return (
                <MuiThemeProvider muiTheme={muiTheme}>
                    <div className="Carta1">
                        <h2>{this.state.legendas.cartaInicial}</h2>
                        <div className="ui-g">
                            <div className="ui-g-7">
                                <Card>
                                    <CardMedia mediaStyle={{ maxWidth: '350px', maxHeight: '550px' }} overlay={<CardTitle titleStyle={{ fontFamily: 'OpenSans' }} subtitleStyle={{ fontFamily: 'OpenSans' }} title={this.state.legendas.LINGUA === 'POR' ? this.state.carta1.titulofrente : this.state.carta1.titulofrenteingles} subtitle={this.state.legendas.LINGUA === 'POR' ? this.state.carta1.tituloverso : this.state.carta1.tituloversoingles} />} style={{ backgroundColor: 'coral' }}>
                                        <img src={this.state.carta1.imgfrente} alt="imagem" />
                                    </CardMedia>
                                </Card>
                            </div>
                            <div className="ui-g-5">
                                <TextField
                                    style={{ maxWidth: '90%', fontFamily: 'Arial', color: 'white' }}
                                    textareaStyle={{ color: 'white' }}
                                    inputStyle={{ color: 'white' }}
                                    hintStyle={{ color: 'white' }}
                                    hintText={this.state.legendas.sobre}
                                    floatingLabelText={this.state.legendas.conte}
                                    floatingLabelStyle={{ color: 'white' }}
                                    multiLine={true}
                                    rows={4}
                                    rowsMax={4}
                                    value={this.state.historiacarta.historia}
                                    onChange={this.handleInputChange}
                                />
                                <RaisedButton containerElement={<Link to="/categoria" />}
                                    linkButton={true}
                                    label={this.state.legendas.avancar}
                                    style={style}
                                    primary={true}
                                />
                            </div>
                        </div>

                    </div>
                </MuiThemeProvider>
            );
        }
    }
}

export default Carta1;



// WEBPACK FOOTER //
// ./src/componentes/carta1/Carta1.js